import { Component } from '@angular/core';
import {Notification, NotificationForm, StatusButtons} from "../../../_shared/interfaces";
import { AlertService, IAlertType, NotificationStoreService, StaffStoreService } from "../../../_shared/services";
import { ActivatedRoute, Router, RouterLink} from "@angular/router";
import { ClrIconModule } from "@clr/angular";
import { JsonPipe, NgIf } from "@angular/common";
import { NotificationFormComponent } from "../notification-form/notification-form.component";
import { ClarityIcons, twoWayArrowsIcon} from "@cds/core/icon";

import { environment as env } from "../../../../environments/environment";

@Component({
  selector: 'app-notification-update',
  standalone: true,
  imports: [
    RouterLink,
    ClrIconModule,
    NgIf,
    NotificationFormComponent,
    JsonPipe
  ],
  templateUrl: './notification-update.component.html',
  styleUrl: './notification-update.component.sass'
})
export class NotificationUpdateComponent {
  projectId: string = '';
  jobId: number = 0;
  notificationData?: Notification;
  notificationId: number = 0;
  loading: boolean = true;
  staffFirstName: string = '';
  staffLastName: string = '';
  staffEMail: string = '';

  devMode: boolean;

  statusButtons: StatusButtons[] = [
    { state: 'running', display: 'In Arbeit', label: 'alert-info', icon: 'info-circle'},
    { state: 'onhold', display: 'Wartet auf Abholung', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'ontour', display: 'On Tour', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'done', display: 'Empfang bestätigt', label: 'alert-success', icon: 'check-circle'}
  ];

  constructor(
    private notss: NotificationStoreService,
    private staffss: StaffStoreService,
    private alertDispatcher: AlertService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
    this.devMode = env.stages.dev;
  }

  ngOnInit(): void {
    const params = this.route.snapshot.paramMap;
    this.projectId = params.get('prid') ?? '';
    this.jobId = parseInt(params.get('jobid') ?? '0', 10);
    this.notificationId = parseInt(params.get('notid') ?? '0', 10);
    this.loadNotification(this.projectId, this.notificationId);
  }

  loadNotification(prid: string, notid: number){
    this.notss.getNotification(prid, notid, 0, 0, 0).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Notificationdaten gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
        const notification = data.object[0];
        this.notificationData = notification;
        this.jobId = Number(notification?.job_id || this.jobId);
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    });
  }

  updateNotification(notification: NotificationForm) {
    this.notss.updateNotification(notification)
      .subscribe({
        next: () => {
          this.alertDispatcher.alertConfig.message = 'Mitteilung wurde aktualisiert!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;
        },
        complete: () => {
          this.router.navigate([`notification/details/${this.projectId}/${this.jobId}/${this.notificationId}`]).then();
        },
        error: () => {
          return
        }
      });
  }

  staffStatus(staffID: number) {
    this.staffss.getStaffById(staffID)
      .subscribe({
        next: staff => {
          this.staffFirstName = staff.object[0].firstname;
          this.staffLastName = staff.object[0].lastname;
          this.staffEMail = staff.object[0].email;
        },
        complete: () => {
        },
        error: () => {
          return
        }
      });
  }
}
